import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import React, { useState } from "react";
import { parse } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Benefit(props) {
    // Expected props:
    //   benefitNum: the number of this benefit (1, 2, etc)
    //   benefitName: (optional) the name of this benefit
    //   benefitCategories: (optional) the categories this benefit applies to, paragraph, one per line
    // console.log(props);
    const benefitId = "benefit"+props.benefitNum;
    const categoriesId = "categories"+props.benefitNum;
    const expirationId = "expirationDate"+props.benefitNum;
    let loadedDate = "";
    if (props.expirationDate) {
        loadedDate = parse(props.expirationDate, 'MM/dd/yyyy', new Date())
    }
    const [expirationDate, setExpirationDate] = useState(loadedDate);
   
    return (
        <>
            <hr style={{height: "3px", backgroundColor: "black", border: "none"}}></hr>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Benefit (<em>1.5% off, etc</em>)
                </Form.Label>
                <Col sm="10">
                    <Form.Control id={benefitId} defaultValue={props.benefitName} />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Categories, one per line (<em>restaurants, gas, etc</em>)
                </Form.Label>
                <Col sm="10">
                    <Form.Control as="textarea" id={categoriesId} defaultValue={props.benefitCategories} />
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Good through: (<em>leave blank for no expiration date</em>)
                </Form.Label>
                <Col sm="10">
                    <DatePicker id={expirationId} selected={expirationDate} onChange={(date) => setExpirationDate(date)} />
                </Col>
            </Form.Group>
        </>
    );
}

export default Benefit;